export default __webpack_public_path__ + "static/media/Bandeau 1.d65fc1d1.jpg";